import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["poster", "width", "height"]
const _hoisted_2 = ["data-src", "src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'webm-video',
  props: {
    src: {},
    posterUrl: {},
    lazyload: { type: Boolean, default: true },
    width: {},
    height: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("video", {
    class: _normalizeClass({ lazy: _ctx.lazyload }),
    playsinline: "",
    loop: "",
    muted: "",
    autoplay: "",
    poster: _ctx.posterUrl,
    width: _ctx.width,
    height: _ctx.height
  }, [
    _createElementVNode("source", {
      "data-src": _ctx.lazyload ? _ctx.src : null,
      src: !_ctx.lazyload ? _ctx.src : null,
      type: "video/webm"
    }, null, 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})